import axios from "axios";
import { getPreferredLanguage } from "../../../helpers";
var tveProviderListQuery = "query ($device: Device!, $domain: String, $siteId: String, $country: String, $language: String) {\n  bootstrap(device: $device, domain: $domain, siteId: $siteId, country: $country, language: $language) {\n    appcmsPlatform {\n      tveSettings {\n        \n        providers\n        {\n          identifier\n          imageUrl\n          logoUrl\n          title\n          fwIdentifier\n        }\n      }\n    }\n    \n  }\n}";
export var getTveProviderList = function () {
    var _a, _b, _c;
    var baseUrl = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.apiConfig) === null || _c === void 0 ? void 0 : _c.apiBaseUrl;
    var endpoint = "".concat(baseUrl, "/graphql");
    var requestHeaders = {
        "X-Forwarded-For": (window === null || window === void 0 ? void 0 : window.ip) || '',
    };
    var variables = {
        "domain": location.host,
        "device": "WEB",
        "country": null,
        "language": getPreferredLanguage() || 'en'
    };
    var finalPayload = {
        "query": tveProviderListQuery,
        "variables": variables,
    };
    return axios.post(endpoint, finalPayload, requestHeaders).then(function (response) {
        return response;
    }).catch(function (error) {
        if (error.response) {
            console.log(error.response.data);
        }
        else {
            console.log(error, 'Error');
        }
    });
};
